import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { MdOutlineSort, MdWarningAmber } from "react-icons/md";
import "bootstrap/dist/css/bootstrap.min.css";

const TabellaAnomalie = () => {
  const [anomalie, setAnomalie] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

  useEffect(() => {
    fetch("./ordini_urgenti.json")
      .then((res) => res.json())
      .then((data) => {
        const arrayAnomalie = data?.ANOMALIE || [];
        setAnomalie(arrayAnomalie.flat());
        setLoading(false);
      })
      .catch((err) => {
        console.error("Errore fetch:", err);
        setLoading(false);
      });
  }, []);

  const requestSort = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });

    const sortedData = [...anomalie].sort((a, b) => {
      if (a[key] < b[key]) return direction === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return direction === 'asc' ? 1 : -1;
      return 0;
    });
    setAnomalie(sortedData);
  };

  const formatData = (dateStr) => {
    if (!dateStr) return "-";
    const soloData = dateStr.split(" ")[0];
    return soloData.split("-").reverse().join("/");
  };

  const getStatusStyle = (dateStr) => {
    if (!dateStr) return { borderLeft: "4px solid #e0e0e0" };
    const dataRimesso = new Date(dateStr.split(" ")[0]);
    const oggi = new Date();
    const diffDays = Math.floor((oggi - dataRimesso) / (1000 * 60 * 60 * 24));

    if (diffDays >= 15) return { borderLeft: "4px solid #800020", backgroundColor: "rgba(128, 0, 32, 0.05)" };
    if (diffDays >= 7) return { borderLeft: "4px solid #ff3e3e", backgroundColor: "rgba(255, 62, 62, 0.05)" };
    if (diffDays >= 3) return { borderLeft: "4px solid #ffd1dc", backgroundColor: "rgba(255, 209, 220, 0.2)" };
    
    return { borderLeft: "4px solid #e0e0e0" };
  };

  return (
    <div className=" shadow-lg card  tb" style={{ 
        borderRadius: "12px", border: "1px solid #dee2e6", height: "400px", 
        display: "flex", flexDirection: "column", overflow: "hidden", backgroundColor: "#fff" 
    }}>
      {/* Header Widget */}
      <div className="p-3 bg-light border-bottom d-flex justify-content-between align-items-center">
        <span style={{ fontWeight: "700", fontSize: "0.75rem", color: "#495057", letterSpacing: "1px" }}>
            ANOMALIE RILEVATE
        </span>
        <span className="badge rounded-pill bg-warning text-dark" style={{ fontSize: "0.65rem" }}>
            <MdWarningAmber /> {anomalie.length} ALERT
        </span>
      </div>

      <style>{`
        .scroll-area { overflow-y: auto; flex-grow: 1; }
        .scroll-area::-webkit-scrollbar { width: 6px; }
        .scroll-area::-webkit-scrollbar-thumb { background: #ccc; border-radius: 10px; }
        
        .table-anomalie { margin-bottom: 0; table-layout: fixed; width: 100%; }
        .table-anomalie thead th { 
            position: sticky; top: 0; z-index: 10; 
            background-color: #f8f9fa !important; color: #6c757d !important; 
            font-size: 0.65rem; text-transform: uppercase; padding: 12px 8px;
            border-bottom: 2px solid #dee2e6 !important;
            cursor: pointer;
            white-space: nowrap;
        }
        .table-anomalie tbody td { 
            font-size: 0.72rem; padding: 10px 8px; 
            vertical-align: middle; border-bottom: 1px solid #f2f2f2;
            white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
        }
        .table-anomalie tbody tr:hover { background-color: #fcfcfc !important; }
        
        .sort-icon { font-size: 0.8rem; color: #adb5bd; margin-left: 3px; }
      `}</style>
      
      <div className="scroll-area ">
        <Table hover className="table-anomalie">
          <thead>
            <tr>
              <th style={{ width: "120px" }}>Causale</th>
              <th style={{ width: "180px" }}>Ragione Sociale</th>
              <th onClick={() => requestSort('data_rimesso')} style={{ width: "100px" }}>
                Data Rim. <MdOutlineSort className="sort-icon" />
              </th>
              <th style={{ width: "90px" }}>Num. Rim</th>
              <th style={{ width: "60px" }}>Dep</th>
              <th style={{ width: "80px" }}>Articolo</th>
              <th style={{ width: "50px" }}>Qta</th>
              <th onClick={() => requestSort('data_completamento_bem')} style={{ width: "100px" }}>
                Compl. <MdOutlineSort className="sort-icon" />
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="8" className="text-center py-5 text-muted">Scansione anomalie...</td></tr>
            ) : (
              anomalie.map((item, index) => {
                const statusStyle = getStatusStyle(item.data_rimesso);
                return (
                  <tr key={index}>
                    <td style={statusStyle} title={item.causale}>
                        <span className="badge bg-light text-secondary border">{item.causale}</span>
                    </td>
                    <td className="fw-bold">{item.ragione_sociale}</td>
                    <td>{formatData(item.data_rimesso)}</td>
                    <td>{item.numero_rimesso?.replace(/,$/, "")}</td>
                    <td>{item.deposito}</td>
                    <td title={item.articolo}>{item.articolo}</td>
                    <td className="text-center fw-bold">{parseFloat(item.quantita).toFixed(0)}</td>
                    <td className="text-muted">{formatData(item.data_completamento_bem)}</td>
                  </tr>
                );
              })
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
};

export default TabellaAnomalie;